import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor() {
    fromEvent(document, 'copy').subscribe(this.trimClipboardText);
  }

  trimClipboardText = (event: ClipboardEvent) => {
    const selection = this.getSelectionText();
    const trimmedSelection = selection.trim();
    event.clipboardData.setData('text/plain', trimmedSelection);
    event.preventDefault();
  };

  getSelectionText() {
    try {
      const activeElement = document.activeElement as HTMLInputElement;
      if (activeElement && activeElement.value) {
        return activeElement.value.substring(activeElement.selectionStart, activeElement.selectionEnd);
      } else {
        return document.getSelection().toString();
      }
    } catch (e) {
      return '';
    }
  }
}
